module.exports = __webpack_public_path__ + "img/27.da50edb1.jpg";